// Angular Files
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular Material Files
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';

// Component Files
import { FullPageModalHeaderComponent } from './full-page-modal-header.component';

@NgModule({
    declarations: [FullPageModalHeaderComponent],
    exports: [FullPageModalHeaderComponent],
    imports: [
        CommonModule,
        MatLegacyButtonModule,
        MatIconModule,
    ]
})
export class FullPageModalHeaderModule {}
